import { client } from '@/common-utils/libraries/axios/axios';
import MERCHANT_USER from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import userFields from '../../../monetic/fields/userFields';



/**
 * @param responseData response.data object
 * @param responseData.name string
 * @param responseData.permissions array
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};
    Object.keys(response).forEach(key => {
        data[key] = {
            [userFields.PROFILE_NAME.key]: response[key][userFields.PROFILE_NAME.key],
            [userFields.PROFILE_PERMISSIONS.key]: response[key][userFields.PROFILE_PERMISSIONS.key]
        };
    });
    return data;
}

const queryGetMerchantProfiles = (organizationId) => {
    return {
        queryKey: [MERCHANT_USER.MERCHANT_PROFILE.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(MERCHANT_USER.MERCHANT_PROFILE.url, { organizationId: organizationId }));
            return mapResponseData(response.data);
        },
        enabled: !!organizationId
    };
};

export default queryGetMerchantProfiles;